import { rest } from 'msw'
import moment from 'moment'
moment.locale('ja')
export default [
  rest.post('/api/v2/get_product_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          shopName: '大崎駅前店',
          jan: '4999999999999',
          dispJan: '5999999999999',
          name: 'エビピラフ',
          prflag: 1,
          image: [
            'https://placehold.jp/150x150.png',
            'https://placehold.jp/150x150.png',
            'https://placehold.jp/150x150.png',
          ],
          imageAttribute: [
            {
              height: 150,
              width: 150,
            },
            {
              height: 150,
              width: 150,
            },
            {
              height: 150,
              width: 150,
            },
          ],
          listImage:
            'https://content.retailstudio.jp/images/0001/dp/0001_02.jpg',
          maker: {
            id: 1,
            name: 'ニチレイ',
            logo: 'https://content.retailstudio.jp/images/logo/0000/01.jpg',
          },
          brand: {
            id: 1,
            name: 'コカ・コーラ',
            logo: 'https://content.retailstudio.jp/images/logo/0001/01.jpg',
          },
          prices: [
            {
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(-1, 'days').unix(),
              remark: '+30P',
              remark2: '+30P',
            },
            {
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(2, 'days').unix(),
              remark: '+30P',
              remark2: '',
            },
          ],
          stock: null,
          review: null,
          chart: null,
          details: [
            { title: 'jan_code', body: 'code number' },
            { title: 'brand_maker_name', body: '味の素' },
            { title: 'product_standard', body: '600g' },
            { title: 'comment', body: 'comments' },
            { title: 'extra detail', body: 'test' },
          ],
          description: null,
          isFollow: 0,
          responseTime: '915148799',
        },
      })
    )
  }),
]
